import { render, staticRenderFns } from "./ModalCadastroEtapa.vue?vue&type=template&id=d13c13dc&scoped=true"
import script from "./ModalCadastroEtapa.vue?vue&type=script&lang=js"
export * from "./ModalCadastroEtapa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d13c13dc",
  null
  
)

export default component.exports